import * as React from "react";
const SvgNavigateUpFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm-7.94 5.002h-.119a1 1 0 0 0-.648.29l-7 7a1 1 0 1 0 1.414 1.415L12 9.415l6.293 6.292a1 1 0 0 0 1.414-1.414l-7-7a1 1 0 0 0-.648-.291", clipRule: "evenodd" }));
export default SvgNavigateUpFill;
